
        Component.define('modal', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $boxModal = $el.find('.box');

$el.on('modal:open', function(evt, params){
    let openModal = false;

    if(params.btnClick){
        openModal = true;
    }

    if(!getCookie(params.name)){
        var now = new Date();
        var minutes = 30;
        now.setTime(now.getTime() + (minutes * 60 * 1000));

        let cookie = {};
        cookie[params.name] = 1;

        createCookie(cookie, now.toUTCString());

        openModal = true;
    }

    if(openModal){
        $el.fadeIn();
        TweenMax.set($boxModal, {y: 0});
        TweenMax.from($boxModal, .6, {y: -100, ease: Expo.easeOut });
        $el.find('.title').html(params.title);
        $el.find('.msg').html(params.message);
        $body.addClass('modal-opened');
        $body.addClass(params.name || '');
    }
});

$el.on('modal:close', function(evt, params){
    $el.fadeOut();
    $body.removeClass('modal-opened');
});

$el.find('.btn-close').on('click', function(){
    $el.trigger('modal:close');
});

$el.find('.wrapper').on('click', function(e){
    if( e.target !== this) return;
    $el.trigger('modal:close');
});

document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
        $el.trigger('modal:close');
    }
};


function keepConnect() {
    let expire = new Date();
    let limit  = expire.getMonth() + 6;

    if (limit > 11) {
        expire.setMonth(limit - 12);
        expire.setFullYear(expire.getFullYear() + 1);
    } else {
        expire.setMonth(limit);
    }

    return expire;
}

function createCookie(data, limit) {
    for (let item in data) {
        document.cookie = `${item}=${data[item]}; expires=${limit}; path=/`;
    }
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
}


        });